import * as Yup from 'yup';
import { ShopType } from '../entities/shop.entity';
import Address from '../entities/address.entity';

export interface ShopForm {
  contactEmail: string;
  label: string;
  groupId: string;
  imageUrl: string | null;
  address?: Address | null;
  prestashopAuthToken: string;
  prestashopShopId?: number;
  prestashopLangId?: number;
  prestashopAddressId?: number;
  prestashopBaseUrl?: string;
  prestashopCarrierId?: number;
  prestashopCurrencyId?: number;
  prestashopGroupShopId?: number;
  prestashopCustomerGroupId?: number;
  prestashopModuleId?: string;
  prestashopPaidStateId?: number;
  prestashopCanceledStateId?: number;
  prestashopPaymentFailedStateId?: number;
  prestashopWaitingPaymentStateId?: number;
  prestashopCategoryParentId?: number;
  type: ShopType;
  isDisabled: boolean;
}

export type ShopFormShape = {
  [key in keyof ShopForm]?: any;
};

export const schema = Yup.object().shape<ShopFormShape>({
  label: Yup.string().required('Digite o nome da loja'),
  contactEmail: Yup.string().optional().email('Digite um email válido'),
});
